import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

const StoreInfoLogo = ({
  logoUrl,
  onUpload,
  useLogo
}) => {
  return (
    <div>
      <h5>Logo</h5>
      <div className="row">
        <div className="col-sm-4">
          <div className="company-logo">
            {(useLogo && logoUrl !== null) && <img src={logoUrl} alt="Store Logo" title="Store Logo"/>}
          </div>
        </div>
        <div className="col-sm-8">
          <label className="custom-file">
            <input type="file" id="file" className="custom-file-input" accept="image/jpeg, image/png" onChange={(e) => {onUpload(e.target.files[0]);}}/>
            <span className="custom-file-control">{I18n.t('UPLOAD_LOGO')}</span>
          </label>
          <p className="logo-description">{I18n.t('STORE_LOGO_DETAILS')} 
          <span>{I18n.t('STORE_LOGO_FORMATS')}</span></p>
        </div>
      </div>
    </div>
  );
};

StoreInfoLogo.propTypes = {
  logoUrl: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  useLogo: PropTypes.bool.isRequired
};

export default StoreInfoLogo;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/StoreInfoLogo.js
 **/